import { request } from '@/utils/request'

const ContactRequestReason = {
    CeoChange: 'CeoChange',
    ManagementTrack: 'ManagementTrack',
    PremiumDiligence: 'PremiumDiligence',
}

export default {
    requestContactCeoChange() {
        return request.post('/api/sales/contact-request', { reason: ContactRequestReason.CeoChange })
    },
    requestContactManagementTrack() {
        return request.post('/api/sales/contact-request', { reason: ContactRequestReason.ManagementTrack })
    },
    requestContactPremiumDiligence(originUri) {
        return request.post('/api/sales/contact-request', { reason: ContactRequestReason.PremiumDiligence, originUri })
    },
}
